import React, { useState, useContext, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../../../axios/index";
import { useLocation, Link } from "react-router-dom";

// context
import { UserContext } from "../../../Context/UserContextProvider";

//Styles
import styles from "../../../Dashboard/DashboardReuseAbleComponents/AddNewFile.module.css";
import Dstyles from "../../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";
import userStyles from "./EditFile.module.css";

// Re Useable Components
import AddNewFileDropdown from "../../../Dashboard/DashboardReuseAbleComponents/AddNewFiles/AddNewFileDropdown";
import HomeNavbar from "../../../Home/HomeNavbar/HomeNavbar";
import UserSideDashboard from "../../UserSideDashboard/UserSideDashboard";
import Footer from "../../../Home/Footer/Footer";
import { editCardValidate } from "./../../../Dashboard/DashboardFileManagement/CardDetail/EditCard/editCardValidate";
import Images from "./../../../Dashboard/DashboardFileManagement/CardDetail/EditCard/Images";
import SelectFacilitiesModal from "./../../../Dashboard/DashboardReuseAbleComponents/AddNewFiles/SelectFacilitiesModal";
import PlacesInput from "./../../../Dashboard/DashboardReuseAbleComponents/AddNewFiles/PlacesInput";
import { Editor } from "@tinymce/tinymce-react";

//images
import arrowIcon from "../../../../assets/img/DashboardICons/ArrowRounded.svg";
import arrowBlue from "../../../../assets/img/DashboardICons/Chevron left blue.svg";
import addIcon from "../../../../assets/img/DashboardICons/AddIconBlue.svg";

const EditFile = props => {
  // const id = props.match.params.id;
  const { userToken } = useContext(UserContext);
  const { state } = useLocation();
  const history = useHistory();
  const [modalShow2, setModalShow2] = useState(false);
  const [mapData, setMapData] = useState({
    lat: 38.065577,
    lng: 46.382126,
  });
  const [errors, setErrors] = useState({});
  const [loadedImages, setLoadeImages] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [btnLoader, setBtnLoader] = useState(false);
  const [editedData, setEditedData] = useState();
  const [addedFacilitiesID, setAddedFacilitiesID] = useState([]);
  const [facilitiData, setFacilitiData] = useState();
  const [addedFacilities, setAddedFacilities] = useState([]);
  const [images, setImages] = useState();

  const description = useRef(null);
  const [fileData, setFileData] = useState({
    title: "",
    meter: "",
    address: "",
    mortgage: "",
    rent: "",
    totalPrice: "",
    metrajPrice: "",
    description: "",
    saleOrRent: "",
    shortAddress: "",
    city: "",
    place: "",
    year: "",
    room: "",
    floor: "",
    unitsNumber: "",
  });

  const removeSymbolNumberHandler = e => {
    const removeSymbolNumber = ["e", "E", ".", "-"];

    if (removeSymbolNumber.includes(e.key)) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    const getData = async () => {
      const getEditData = await axios.get(`Estate/bySlug/${state.state.slug}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      const editedData = getEditData.data.data;

      const getApiData = await axios.get(`Specification/GetList`, {
        headers: { authorization: "Bearer " + userToken },
      });

      setEditedData(editedData);
      if (editedData.address.location) {
        const locationData = editedData.address.location.split(",");
        setMapData(() => {
          return { lat: parseFloat(locationData[0]), lng: parseFloat(locationData[1]) };
        });
      }
      await setFileData(prev => {
        return {
          ...prev,
          title: editedData.title,
          meter: editedData.meterage,
          address: editedData.address.fullAddress,
          shortAddress: editedData.address.shortAddress,
          mortgage: editedData.mortgagePrice,
          rent: editedData.rentPrice,
          totalPrice: editedData.totalPrice,
          metrajPrice: editedData.meteragePrice,
          description: editedData.description,
          saleOrRent: editedData.rentPrice === null || editedData.rentPrice === 0 ? "sale" : "rent",
          city: editedData.address.city,
          place: editedData.address.zone,
          year: editedData.constructionYear,
          room: editedData.roomCount,
          floor: editedData.floor,
          fileFound: editedData.searchType,
          unitsNumber: editedData?.unitsNumber,
        };
      });

      setLoadeImages(editedData.images);
      var customeSpecifications = editedData.facilities.split(",");
      setAddedFacilities(customeSpecifications);
      setFacilitiData(getApiData.data.data);
      const filterdObjects = getApiData.data.data.filter(obj => {
        return customeSpecifications.includes(obj.title);
      });
      setAddedFacilitiesID(filterdObjects.map(item => item.id));

      setIsLoading(false);
    };
    getData();
  }, [state, userToken]);

  useEffect(() => {
    setErrors(editCardValidate(fileData, images, loadedImages, state.userAdd ? true : false));
  }, [fileData, images, loadedImages, state.userAdd]);

  return (
    <>
      <SelectFacilitiesModal
        show={modalShow2}
        onHide={() => setModalShow2(false)}
        addedFacilities={addedFacilities}
        setAddedFacilities={setAddedFacilities}
        facilitiData={facilitiData}
        itemID={facilitiData}
        addedFacilitiesID={addedFacilitiesID}
        setAddedFacilitiesID={setAddedFacilitiesID}
      />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir="rtl">
          <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar />
            <div className="container py-3 px-0 mt-4">
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
              />
              <form onSubmit={e => e.preventDefault()} className="w-100 d-flex justify-content-md-between justify-content-center align-items-start">
                <UserSideDashboard myAds />

                <div className={`d-flex flex-column align-items-center justify-content-start px-3 py-4 ${userStyles.main_container}`}>
                  {/* Rent Type Header start */}
                  <div className="w-100 d-flex align-items-center justify-content-center justify-content-md-start flex-wrap my-3">
                    <Link to="/user-files">
                      <img className="ms-2 pointer" src={arrowIcon} alt="icon" />
                    </Link>
                    <div className={Dstyles.text1}>{editedData?.title}</div>
                  </div>
                  {/* Rent Type Header end */}

                  {/* title input start */}
                  <div className="w-100 d-flex justify-content-between align-items-start mb-4">
                    <div className="w-100 d-flex align-items-start justify-content-center flex-column ms-2">
                      <div className={`mb-3 ${styles.input_header}`}>عنوان</div>
                      <input
                        type="text"
                        name="title"
                        value={fileData.title}
                        onChange={changeHandler}
                        // onKeyDown={(e) => e.keyCode == 13 ? e.preventDefault() : ''}
                        className={`w-100 bg-light py-2 pe-3 ${styles.input}`}
                        placeholder="مثلا آپارتمان ۳۰۰ متر تختی"
                      />
                    </div>
                  </div>
                  {/* title input end */}

                  {/* sub menus row1 */}
                  <div className="d-flex align-items-center justify-content-md-between justify-content-center mt-2 mb-3 flex-wrap">
                    <AddNewFileDropdown setDropDownsData={setFileData} yearName={fileData.year} year userAdd={true} />

                    <PlacesInput placeName={fileData.place} setDropDownsData={setFileData} userAdd={true} />

                    <AddNewFileDropdown cityName={fileData.city} setDropDownsData={setFileData} city userAdd={true} />
                  </div>
                  {/* sub menus row1 */}

                  {/* sub menus row2 */}
                  <div className="d-flex align-items-center justify-content-md-between justify-content-center mt-2 mb-3 flex-wrap gap-1">
                    <AddNewFileDropdown setDropDownsData={setFileData} floorNumber={fileData.floor} floor userAdd={true} />
                    <AddNewFileDropdown setDropDownsData={setFileData} roomNumber={fileData.room} room userAdd={true} />
                    <div className="py-2">
                      <div className="container-fluid">
                        <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center" dir="rtl">
                          <div className="d-flex flex-column justify-content-center align-items-start">
                            <div className={`mb-3 ${styles.input_header}`}>متراژ</div>
                            <label className="position-relative" for="meter">
                              <span className={styles.input_left_text}>متر</span>
                              <input
                                type="number"
                                name="meter"
                                value={fileData.meter}
                                onChange={changeHandler}
                                onKeyDown={e => (e.keyCode == 13 ? e.preventDefault() : "")}
                                className={`bg-light py-2 ps-5 pe-2 text-end ${styles.input_meter_user}`}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* sub menus row2 */}

                  {/* address */}
                  <div className="w-100 text-end px-2 d-flex justify-content-md-start justify-content-center flex-wrap align-items-end my-3" dir="rtl">
                    <div className={`d-flex flex-column justify-content-center align-items-start mb-xl-0 mb-3 ${styles.address_input_container_user}`}>
                      <div className={`mb-3 ${styles.input_header}`}>آدرس دقیق</div>
                      <input
                        type="text"
                        name="address"
                        value={fileData.address}
                        onChange={changeHandler}
                        className={`w-100 bg-light py-2 pe-3 ${styles.input}`}
                      />
                    </div>
                    {/* <div className="d-flex justify-content-center align-items-center mb-2 me-4 mt-xl-0 mt-3">
                                            <div onClick={() => setModalShow(true)} className={styles.text_primary}>
                                                انتخاب آدرس از روش نقشه
                                                <img className='me-2' src={arrowBlue} alt="icon" />
                                            </div>

                                        </div> */}
                  </div>
                  {/* address */}

                  <div className="w-100 text-end px-2 d-flex justify-content-md-start justify-content-center flex-wrap align-items-end my-3" dir="rtl">
                    <div className={`d-flex flex-column justify-content-center align-items-start mb-xl-0 mb-3 ${styles.address_input_container_user}`}>
                      <div className={`mb-3 ${styles.input_header}`}>آدرس حدودی</div>
                      <input
                        type="text"
                        name="shortAddress"
                        value={fileData.shortAddress}
                        onChange={changeHandler}
                        className={`bg-light py-2 pe-3 text-end ${styles.input_meter}`}
                      />
                    </div>
                  </div>

                  <div className="w-100 text-end px-2 d-flex justify-content-md-start justify-content-center flex-wrap align-items-end my-3" dir="rtl">
                    <div className={`d-flex flex-column justify-content-center align-items-start mb-xl-0 mb-3 ${styles.address_input_container_user}`}>
                      <div className={`mb-3 ${styles.input_header}`}>تعداد واحد در هر طبقه</div>
                      <input
                        type="number"
                        name="unitsNumber"
                        value={fileData.unitsNumber}
                        onChange={changeHandler}
                        onKeyDown={removeSymbolNumberHandler}
                        className={`bg-light py-2 pe-3 text-end ${styles.input_meter}`}
                      />
                    </div>
                  </div>

                  {/* prices */}
                  <div className="w-100 text-end px-2 d-flex justify-content-md-start justify-content-center flex-wrap align-items-center my-3" dir="rtl">
                    <div className="d-flex flex-column justify-content-center align-items-start flex-wrap">
                      <div className={`mb-4 ${styles.title_bold}`}>
                        {editedData.rentPrice === null || editedData.rentPrice === 0 ? "قیمت هرمتر و قیمت کل" : "قیمت رهن و اجاره"}
                      </div>
                      <div className="d-flex align-items-center justify-content-center flex-wrap">
                        <div className="d-flex flex-column justify-content-center align-items-start ms-md-2 mb-md-0 mb-3">
                          {editedData.rentPrice === null || editedData.rentPrice === 0 ? (
                            <>
                              <div className={`mb-3 ${styles.input_header}`}>قیمت کل</div>
                              <label className="position-relative" for="totalPrice">
                                <span className={styles.input_left_text}>تومان</span>
                                <input
                                  type="number"
                                  name="totalPrice"
                                  value={fileData.totalPrice}
                                  onChange={changeHandler}
                                  onKeyDown={e => (e.keyCode == 13 ? e.preventDefault() : "")}
                                  className={`bg-light py-2 ps-5 pe-2 text-end ${styles.input_meter_user}`}
                                />
                              </label>
                            </>
                          ) : (
                            <>
                              <div className={`mb-3 ${styles.input_header}`}>رهن</div>
                              <label className="position-relative" for="mortgage">
                                <span className={styles.input_left_text}>تومان</span>
                                <input
                                  type="number"
                                  name="mortgage"
                                  value={fileData.mortgage}
                                  onChange={changeHandler}
                                  onKeyDown={e => (e.keyCode == 13 ? e.preventDefault() : "")}
                                  className={`bg-light py-2 ps-5 pe-2 text-end ${styles.input_meter_user}`}
                                />
                              </label>
                            </>
                          )}
                        </div>

                        <div className="d-flex flex-column justify-content-center align-items-start me-md-2 mt-md-0 mt-3">
                          {editedData.rentPrice === null || editedData.rentPrice === 0 ? (
                            <>
                              <div className={`mb-3 ${styles.input_header}`}>قیمت هر متر</div>
                              <label className="position-relative" for="metrajPrice">
                                <span className={styles.input_left_text}>تومان</span>
                                <input
                                  type="number"
                                  name="metrajPrice"
                                  value={fileData.metrajPrice}
                                  onChange={changeHandler}
                                  onKeyDown={e => (e.keyCode == 13 ? e.preventDefault() : "")}
                                  className={`bg-light py-2 ps-5 pe-2 text-end ${styles.input_meter_user}`}
                                />
                              </label>
                            </>
                          ) : (
                            <>
                              <div className={`mb-3 ${styles.input_header}`}>اجاره</div>
                              <label className="position-relative" for="rent">
                                <span className={styles.input_left_text}>تومان</span>
                                <input
                                  type="number"
                                  name="rent"
                                  value={fileData.rent}
                                  onChange={changeHandler}
                                  onKeyDown={e => (e.keyCode == 13 ? e.preventDefault() : "")}
                                  className={`bg-light py-2 ps-5 pe-2 text-end ${styles.input_meter_user}`}
                                />
                              </label>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* prices */}

                  {/* owner Detail */}
                  {/* <div className="w-100 text-end px-2 d-flex justify-content-md-start justify-content-center flex-wrap align-items-center my-3" dir="rtl" >
                                        <div className='d-flex w-100 flex-column justify-content-center align-items-start flex-wrap'>
                                            <div className={`mb-4 ${styles.title_bold}`}>
                                                اطلاعات مالک
                                            </div>
                                            <div className='w-100 d-flex align-items-center justify-content-md-start justify-content-center flex-wrap'>
                                                <div className='d-flex flex-column justify-content-center align-items-start mt-md-0 mt-3 ms-md-2'>
                                                    <div className={`mb-3 ${styles.input_header}`}>
                                                        شماره تلفن مالک
                                                    </div>
                                                    <label className='position-relative' htmlFor="ownersPhone">
                                                        <input
                                                            type="number"
                                                            name="ownersPhone"
                                                            value={fileData.ownersPhone}
                                                            onChange={changeHandler}
                                                            className={`bg-light py-2 ps-5 pe-2 text-end ${styles.input_meter_user}`}
                                                            onKeyDown={removeSymbolNumberHandler}
                                                        />
                                                    </label>
                                                </div>
                                                <div className='d-flex flex-column justify-content-center align-items-start mt-md-0 mt-3 me-md-3'>
                                                    <div className={`mb-3 ${styles.input_header}`}>
                                                        شماره تلفن ثابت مالک
                                                    </div>
                                                    <label className='position-relative' htmlFor="ownerLandline">
                                                        <input
                                                            type="number"
                                                            name="ownerLandline"
                                                            value={fileData.ownerLandline}
                                                            onChange={changeHandler}
                                                            className={`bg-light py-2 ps-5 pe-2 text-end ${styles.input_meter_user}`}
                                                            onKeyDown={removeSymbolNumberHandler}
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                  {/* owner Detail */}

                  {/* upload img */}
                  <Images
                    images={images}
                    setImages={setImages}
                    loadedImages={loadedImages}
                    setLoadeImages={setLoadeImages}
                    deleteImgHandler={deleteImgHandler}
                    userAdd
                  />
                  {/* upload img */}

                  {/* MoreFacilities */}
                  <div className={`w-100 text-end px-3 my-4 pointer `}>
                    <button className={`${styles.outline_btn}`} onClick={() => setModalShow2(true)}>
                      افزودن امکانات
                      <img className="mx-2" src={addIcon} alt="icon" />
                    </button>
                  </div>
                  {/* MoreFacilities */}

                  {/* Description */}
                  <div className="w-100 text-end px-2 d-flex justify-content-md-between justify-content-center flex-wrap align-items-center my-3" dir="rtl">
                    <div className="w-100 d-flex flex-column justify-content-center align-items-start mb-4">
                      <div className={`mb-3 ${styles.input_header}`}>توضیحات</div>
                      <Editor
                        tinymceScriptSrc={`${process.env.PUBLIC_URL}/assets/tinymce/tinymce.min.js`}
                        onInit={(evt, editor) => (description.current = editor)}
                        initialValue={fileData?.description}
                        init={{
                          height: 350,
                          width: "100%",
                          menubar: true,
                          resize: false,
                          directionality: "rtl",
                          plugins: [
                            "advlist",
                            "autolink",
                            "lists",
                            "link",
                            "anchor",
                            "code",
                            "charmap",
                            "preview",
                            "anchor",
                            "searchreplace",
                            "visualblocks",
                            "fullscreen",
                            "insertdatetime",
                            "table",
                            "help",
                            "wordcount",
                          ],
                          toolbar:
                            "undo redo | casechange blocks | bold italic backcolor | " +
                            "alignleft aligncenter alignright alignjustify | " +
                            "bullist numlist checklist outdent indent | removeformat | a11ycheck code table help",
                          content_style: "body { font-family:Vazir,Arial,sans-serif; font-size:14px, direction:rtl }",
                        }}
                      />
                    </div>
                  </div>
                  {/* Description */}

                  {/* Save Btn */}
                  <div className="w-100 text-start px-2 d-flex justify-content-md-between justify-content-center flex-wrap align-items-center my-3" dir="rtl">
                    <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center">
                      {btnLoader ? (
                        <div className={Dstyles.btn_loader_container}>
                          <div className={Dstyles.btn_spinner}></div>
                        </div>
                      ) : (
                        <button className={`d-flex align-items-center justify-content-center ${styles.save_btn}`} type="submit" onClick={submitHandler}>
                          ویرایش
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Save Btn */}
                </div>
              </form>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );

  function changeHandler(event) {
    if (event.target.name === "slug") {
      let value = event.target.value;
      value = value.replace(/[^A-Za-z-0-9]/gi, " ");
      setFileData(prev => {
        return { ...prev, slug: value };
      });
    } else if (event.target.name === "ownersPhone") {
      if (event.target.value === "" || event.target.value.match(/^[0-9]+$/)) {
        if (event.target.value.length <= 11) {
          setFileData(prev => {
            return { ...prev, [event.target.name]: event.target.value };
          });
        }
      }
    } else if (event.target.name === "Radio") {
      setFileData(prev => {
        return { ...prev, fileFound: event.target.value };
      });
    } else {
      setFileData(prev => {
        return { ...prev, [event.target.name]: event.target.value };
      });
    }
  }

  async function deleteImgHandler(item) {
    const data = {
      imageId: item.id,
      estateId: item.estateId,
    };
    const postDeleteImg = await axios.post("Estate/removeImage", data, {
      headers: { authorization: "Bearer " + userToken },
    });
  }

  function submitHandler() {
    if (!Object.keys(errors).length) {
      notify("درحال ویرایش فایل", "success");
    } else {
      notify("!لطفا تمام فیلد هارا پرکنید", "error");
    }
  }

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      editEstateHandler();
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  async function editEstateHandler() {
    setBtnLoader(true);

    // Object destructuring for fileData properties
    const { title, meter, room, floor, rent, totalPrice, metrajPrice, mortgage, address, year, city, place, shortAddress, unitsNumber } = fileData;

    try {
      var data = new FormData();
      data.append("EstateId", state.state.id);
      data.append("Title", title);
      data.append("ConstructionDate", "1401/10/19");
      data.append(
        "ConstructionYear",
        year?.toString().replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
      );
      data.append("Meterage", meter);
      data.append(
        "RoomCount",
        room?.toString().replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
      );
      data.append(
        "Floor",
        floor?.toString().replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
      );
      data.append("RentPrice", rent ? rent : 0);
      data.append("TotalPrice", totalPrice ? totalPrice : 0);
      data.append("MeteragePrice", metrajPrice ? metrajPrice : 0);
      data.append("MortgagePrice", mortgage ? mortgage : 0);
      data.append("Description", description.current.getContent());
      data.append("CategoryId", editedData.categoryId);
      data.append("SubCategoryId", editedData.subCategoryId);
      data.append("Facilities", addedFacilities);
      data.append("UnitsNumber", unitsNumber);
      data.append("ImageFile", loadedImages ? loadedImages[0].imageFileUrl : images[0].file);
      data.append("Area", 1);
      // data.append('OwnerPhoneNumber', ownerLandline);
      // data.append('OwnerMobileNumber', ownersPhone);
      data.append("Address.Province", address);
      data.append("Address.FullAddress", address);
      data.append(
        "Address.City",
        city?.toString().replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
      );
      data.append(
        "Address.Zone",
        place?.toString().replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
      );
      data.append("Address.ShortAddress", shortAddress);
      data.append("Address.Location", `${mapData.lat}, ${mapData.lng}`);
      // for (const id of addedFacilitiesID) {
      //     data.append('Keys', id?.toString());
      //     // console.log(id?.toString())
      // }
      // for (const value of addedFacilities) {
      //     data.append('Values', value);
      //     // console.log(value)
      // }
      const promises = addedFacilitiesID.map(id => {
        return data.append("Keys", id?.toString());
      });

      await Promise.all(promises);

      const promises2 = addedFacilities.map(value => {
        return data.append("Values", value);
      });

      await Promise.all(promises2);

      if (images) {
        for (const image of images) {
          var imageData = new FormData();
          imageData.append("EstateId", state.state.id);
          imageData.append("ImageFile", image.file);
          const postImg = await axios.post("Estate/addImage", imageData, {
            headers: { authorization: "Bearer " + userToken },
          });
        }
      }

      const apiData = await axios.put("Estate", data, {
        headers: { authorization: "Bearer " + userToken },
      });
      history.push("/user-files");
      setBtnLoader(false);
    } catch (error) {
      // console.log(error)
      notify("خطایی رخ داد", "error");
    }
  }
};

export default React.memo(EditFile);
